const enum Sorting {
  Ascending = 'Ascending',
  Descending = 'Descending',
  None = 'None',
}

export default Sorting;
